/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';

export const PDP_SUBTYPE_CONSTANT = {
  MOBILE_INTERNET: 'MobileInternet',
  PLANS: 'PLANS',
  AVAILABLE: 'Available',
  VOUCHER: 'Voucher',
  INSTOCK: 'In Stock',
  PLAN: 'Plans',
  SERVICE: 'SERVICE',
  INVALID_SIM: 'Invalid SIM',
  LINENUMBER: 'lineNumber',
  ID: 'id',
  ADD: 'ADD',
  SIM: 'SIM',
};

export const QTY_ALLOWED_LIST: string[] = ['Accessory', 'SimCard'];
export const PDL_USER_CONSTANT = {
  AUTHENTICATED: 'Authenticated',
  UNAUTHENTICATED: 'Un-authenticated',
  CUSTOMER: 'Customer',
  PROSPECT: 'Prospect',
  PREPAID: 'Prepaid',
  INDIVIDUAL: 'I',
};

export const CART_EVENT_NAME = {
  CARTADD: 'cartAdd',
  CARTREMOVE: 'cartRemove',
  EMPTYCART: 'Empty Cart',
  CART: 'cart',
};

export const BUTTON_CONSTANTS = {
  SELECT: 'Select Service',
  UNSELECT: 'Unselect Service',
  SELECTPLAN: 'Select Plan',
};

export const PROMO_EVENT_CONSTANTS = {
  PROMOADD: 'promoAdd',
  PROMOREMOVE: 'promoRemove',
  PROMOTION: 'promotion',
};

export const ALERT_EVENT_CONSTANTS = {
  ALERT: 'alert',
  PAGEALERT: 'Page Alert',
};

export const LOAD_EVENT = {
  MODALLOAD: 'modalLoad',
  PAGELOAD: 'pageLoad',
};
export const PLAN_FAMILY = {
  CONNECTPLAN: 'connect-by-t-mobile',
};
export const PDP_CANONICAL_URL_HOLD_PARAM = {
  URL: [
    SHARED_CONSTANTS.DEVICEDETAILURL,
    SHARED_CONSTANTS.PRODUCTSELECTOR,
    SHARED_CONSTANTS.SEARCH,
  ],
};
